import styled from "styled-components";

const ProjectReportsTableColumn = styled.td`
    padding: 0.45rem 0.25rem !important;
    vertical-align: middle;
`;

export default ProjectReportsTableColumn;